import { getTrackingHeadersMap } from "./getTrackingHeaders";
import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IDSEntry } from "../models/dsException";
import { throwApiError } from "./apiError";
import { getTerminalId } from "../helpers";

/**
 * CRETE API call using Axios
 * @returns - Update delivered Short Entry and return same object
 */

export const UpdateDSEntryAPI = async (params: IDSEntry, osdNumber?: number | string) => {
  try {
    // Get static headers from map (do not use || {})
    const staticHeaders = getTrackingHeadersMap(ApiType.DS_ENTRY_UPDATE);
    // Add dynamic values
    const headers = {
      ...staticHeaders,
      "OSD-Exception-Number": osdNumber?.toString(),
      "OSD-Destination-Terminal": getTerminalId(),
    };
    const response = await axios.put(`${getUrl(ApiType.DS_ENTRY_UPDATE)}/${osdNumber}`, params, { headers });
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.updateDSEntry, { badRequestOrder: "errorsFirst" });
  }
};
